import React from "react";
import TodoComponent from "./components/TodoComponent";
import HeadlineComponent from "./news/HeadlineComponent";
function App() {
  return (
    <div className='container'>
      <h1 className='font-custom'>_THEMUKHERJEE</h1>
      <div className='row'>
        <div className='col-xs-12 col-lg-6'>
          <TodoComponent />
        </div>
        <div className='col-xs-12 col-lg-6'>
          <h1 className='font-custom'>TECH NEWS</h1>
          <HeadlineComponent />
        </div>
      </div>
    </div>
  );
}

export default App;
